import { useState, useEffect, useRef } from 'react';
import Search from '@Services/Search';

export default function useFetchBoundOps() {
  const [boundOps, setBoundOpsData] = useState({});
  const isMounted = useRef(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await Search.getExistingBoundOperators();
        if (isMounted.current) {
          setBoundOpsData({ data });
        }
      } catch (error) {
        Logger.error(error);
      }
    };

    fetchData();
    return () => {
      isMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { boundOps };
}
